
import ErpLandingHeader from "./sections/header";
import HrmsLandingFooter from "./sections/footer";
import Hero from "./sections/hero";
import About from "./sections/about";
import FeatureOfHrms from "./sections/featureHrms";
import WhyChooseOurHRSoftware from "./sections/whyOurHRSoftware";
import AllInOneHrms from "./sections/allInOneHrms";
import EmpManagement from "./sections/empMngt"
import OneHRPlatform from "./sections/oneHRPlatform"
import HrmsBusiness from "./sections/hrmsBusiness"
import FaqOfHrms from "./sections/faqOfHrms"
import PricingHrms from "./sections/pricingHrms"
import "./hrmsLandingPage.css";
import { Helmet } from "react-helmet";
import PopUpModal from "../../src/Home/Modal/PopUpModal";
import { useLocation } from "react-router-dom";
import ScrollingHrms from "./sections/scrollingHrms"
import TestimonialsHrms from "./sections/testimonialsHrms"
import Footer from "../Home/Components/Footer"
import Header from "../header/Header"

const LandingPageHrms = () => {
    const Location = useLocation();
    const isHrmsPage = Location.pathname === '/hrms';

    return (
        <>
            <Helmet>
                <title>One HR Software for Payroll, Attendance & Employee Management</title>

                <meta
                    name="description"
                    content="Manage payroll, attendance, leave, and employee data using one unified HRMS software. Improve accuracy, compliance, and productivity with a cloud-based HR platform."
                />

                <meta
                    name="keywords"
                    content="HRMS software, HR payroll software, attendance tracking system, employee management software, unified HRMS platform, HR software India"
                />

                <meta name="viewport" content="width=device-width, initial-scale=1" />


                {/* Open Graph */}
                <meta property="og:title" content="One HR Software for Payroll, Attendance & Employee Management" />
                <meta
                    property="og:description"
                    content="Automate payroll, attendance, leave, and employee management using a single HRMS software built for growing businesses."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.techcognics.com/hrms" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="One HR Software for Payroll, Attendance & Employee Management" />
                <meta
                    name="twitter:description"
                    content="Unified HRMS software to automate payroll, attendance, leave, and employee management."
                />
            </Helmet>
            <PopUpModal />
            {isHrmsPage ? <ErpLandingHeader /> : <Header />}
            <main id="main-content" role="main" >
                <Hero />
                <About />
                <ScrollingHrms />
                <WhyChooseOurHRSoftware />
                <AllInOneHrms />
                <EmpManagement />
                {/* <OneHRPlatform /> */}
                <FeatureOfHrms />
                <FaqOfHrms />
                <PricingHrms />
                <HrmsBusiness />
                <TestimonialsHrms />
            </main>
            {isHrmsPage ? <HrmsLandingFooter /> : <Footer />}
        </>
    );
};


export default LandingPageHrms;
